import Spinner from './Spinner';
import { IconAlertTriangle, IconCheck } from './icons';

function statusIcon(status) {
  if (status === 'ok') return <IconCheck />;
  if (status === 'bad') return <IconAlertTriangle />;
  if (status === 'pending') return <Spinner aria-hidden="true" />;
  return null;
}

export default function DbSteps({ steps }) {
  const list = Array.isArray(steps) ? steps.filter(Boolean) : [];
  return (
    <div className="DbSteps" role="list">
      {list.map((s, idx) => {
        const status = String(s.status || 'disabled');
        return (
          <div key={s.key || `${idx}`} className={`DbStep DbStep--${status}`} role="listitem">
            <div className="DbStepRail" aria-hidden="true">
              <div className="DbStepDot">{statusIcon(status)}</div>
              {idx < list.length - 1 ? <div className="DbStepLine" /> : null}
            </div>
            <div style={{ minWidth: 0 }}>
              <div className="DbStepTitle">{s.title}</div>
              {s.detail ? <div className={`DbStepDetail ${status === 'bad' ? 'DbStepDetail--bad' : ''}`}>{s.detail}</div> : null}
              {s.actions ? <div className="DbStepActions">{s.actions}</div> : null}
            </div>
          </div>
        );
      })}
    </div>
  );
}

